export enum IMAGE_POSITION {
  LEFT = "left",
  CENTER = "center",
  RIGHT = "right",
}
